import { render, staticRenderFns } from "./AspspStatisticsList.vue?vue&type=template&id=fd9db848&"
import script from "./AspspStatisticsList.vue?vue&type=script&lang=js&"
export * from "./AspspStatisticsList.vue?vue&type=script&lang=js&"
import style0 from "./AspspStatisticsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports